import { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
// import { mutate } from 'swr'
// import { useSnackbar } from 'notistack'

import {
  Grid,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography
} from '@mui/material'

import { useTranslation } from '@contexts/translation'
// import { responseHandler } from '@utils/responseHandler'
// import { useAuth } from '@contexts/auth'

const NotifsSettingsForm = ({ onClose }) => {
  //   const { organization } = useAuth()
  const { dictionary } = useTranslation()
  //   const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)

  const { handleSubmit, control } = useForm({
    mode: 'onBlur',
    defaultValues: {
      filter: 'all'
    }
  })

  const onSubmit = async () => {
    setLoading(true)

    // values.action = 'link_to_contact'
    // values.pk_list = contactSelected.map(c => c.id)
    // values.related = +values.related

    // const response = await postContactAction(organization, values)

    // responseHandler({
    //   response,
    //   callback: async () => await mutate(contactsURL),
    //   dictionary,
    //   msgSuccess: dictionary.contact_linked,
    //   snackbar: enqueueSnackbar
    // })

    setLoading(false)
    onClose && onClose()
  }

  return (
    <Grid item xs={12}>
      <form data-cy={'form'} noValidate onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Controller
              name="filter"
              control={control}
              defaultValue="all"
              render={({ field }) => (
                <RadioGroup
                  aria-label="type_aria_label"
                  defaultValue="all"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                  onChange={e => field.onChange(e.target.defaultValue)}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" color="text.secondary">
                        {dictionary.notify_me}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label={
                          <Typography variant="subtitle1" color="text.primary">
                            {dictionary.all_notifications || ''}
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        value="only_me"
                        control={<Radio size="small" />}
                        label={
                          <Typography variant="subtitle1" color="text.primary">
                            {dictionary.only_alert_notif_me || ''}
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        value="only_alerts"
                        control={<Radio size="small" />}
                        label={
                          <Typography variant="subtitle1" color="text.primary">
                            {dictionary.only_alerts || ''}
                          </Typography>
                        }
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="sound_effect"
              control={control}
              defaultValue="all"
              render={({ field }) => (
                <RadioGroup
                  aria-label="type_aria_label"
                  defaultValue="all"
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                  onChange={e => field.onChange(e.target.defaultValue)}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" color="text.secondary">
                        {dictionary.sound_effect_for}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label={
                          <Typography variant="subtitle1" color="text.primary">
                            {dictionary.all_notifications || ''}
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        value="only_alerts"
                        control={<Radio size="small" />}
                        label={
                          <Typography variant="subtitle1" color="text.primary">
                            {dictionary.only_alerts || ''}
                          </Typography>
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        value="deactivate"
                        control={<Radio size="small" />}
                        label={
                          <Typography variant="subtitle1" color="text.primary">
                            {dictionary.deactivate || ''}
                          </Typography>
                        }
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>
              )}
            />
          </Grid>

          <Grid item xs={12} display="flex" justifyContent="space-between">
            <Button
              type="submit"
              color="error"
              variant="outlined"
              onClick={onClose}
            >
              {dictionary.cancel}
            </Button>
            <Button type="submit" disabled={loading}>
              {dictionary.save}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
}

export default NotifsSettingsForm
